/* Product placement is server rendered; this only highlights the reading position. */
document.querySelectorAll('[data-nv-mag-commerce]').forEach(root=>{
 const article=root.querySelector('[data-nv-magazine]');
 if(!article)return;
 const contents=article.querySelector('[data-nv-mag-toc]');
 if(contents){
  contents.open=false;
  matchMedia('(min-width: 901px)').addEventListener('change',()=>{contents.open=false;});
 }
 const links=[...article.querySelectorAll('[data-nv-mag-toc] a[href^="#"]')];
 const entries=links.map(link=>({link,target:article.querySelector(link.getAttribute('href'))})).filter(entry=>entry.target);
 let queued=false;
 function highlight(){
  queued=false;
  const line=window.innerHeight*.3;
  let current=entries[0];
  for(const entry of entries){if(entry.target.getBoundingClientRect().top<=line)current=entry;}
  for(const entry of entries){if(entry===current)entry.link.setAttribute('aria-current','location');else entry.link.removeAttribute('aria-current');}
 }
 function schedule(){if(!queued){queued=true;requestAnimationFrame(highlight);}}
 window.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 highlight();
});
